const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || "G-CMW579HRNC";

export const ANALYTICS_CONSENT_KEY = "briefbref_analytics_consent_v1";
export const ANALYTICS_PREFERENCES_EVENT = "briefbref:analytics-preferences";

const hasBrowser = () => typeof window !== "undefined" && typeof document !== "undefined";

export function getAnalyticsConsent() {
  if (!hasBrowser()) return null;
  try {
    const value = window.localStorage.getItem(ANALYTICS_CONSENT_KEY);
    return value === "granted" || value === "denied" ? value : null;
  } catch {
    return null;
  }
}

function googleTag() {
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };
  return window.gtag;
}

export function loadGoogleAnalytics() {
  if (!hasBrowser() || getAnalyticsConsent() !== "granted") return false;

  const gtag = googleTag();
  if (!document.getElementById("briefbref-google-analytics")) {
    gtag("consent", "default", {
      analytics_storage: "granted",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
    gtag("js", new Date());
    gtag("config", MEASUREMENT_ID, {
      anonymize_ip: true,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
    });

    const script = document.createElement("script");
    script.id = "briefbref-google-analytics";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    document.head.appendChild(script);
  }
  return true;
}

function clearAnalyticsCookies() {
  if (!hasBrowser()) return;
  const hostname = window.location.hostname;
  document.cookie.split(";").forEach((cookie) => {
    const name = cookie.split("=")[0].trim();
    if (!name.startsWith("_ga")) return;
    document.cookie = `${name}=; Max-Age=0; path=/; SameSite=Lax`;
    if (hostname) {
      document.cookie = `${name}=; Max-Age=0; path=/; domain=.${hostname}; SameSite=Lax`;
    }
  });
}

export function setAnalyticsConsent(value) {
  if (!hasBrowser() || (value !== "granted" && value !== "denied")) return;
  try {
    window.localStorage.setItem(ANALYTICS_CONSENT_KEY, value);
  } catch {
    return;
  }

  if (value === "granted") {
    loadGoogleAnalytics();
    return;
  }

  if (window.gtag) {
    window.gtag("consent", "update", { analytics_storage: "denied" });
  }
  clearAnalyticsCookies();
}

function withoutPersonalData(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([key]) => !/(email|name|phone|address)/i.test(key)),
  );
}

export function trackEvent(eventName, params = {}) {
  if (!eventName || !loadGoogleAnalytics() || !window.gtag) return false;
  window.gtag("event", eventName, withoutPersonalData(params));
  return true;
}

export function openAnalyticsPreferences() {
  if (!hasBrowser()) return;
  window.dispatchEvent(new Event(ANALYTICS_PREFERENCES_EVENT));
}
